import { fromISO, getDifference, today } from '../../../../Utils/date';

export const getDaysUntilExpiration = (expiresAfter?: string | null | undefined) => {
  if (!expiresAfter) {
    return 0;
  }

  const diff = getDifference(fromISO(expiresAfter), today()).days + 1;

  if (diff < 0) {
    return 0;
  }

  return diff;
};
